import {
  EinvoiceSummaryDTO,
  SupplyType,
  InvoiceType,
  InvoiceStatus,
} from '../../common/types';

export const einvoiceSummaryDtos: EinvoiceSummaryDTO = {
  invoiceId: '',
  invoiceDate: '',
  invoiceNumber: '',
  buyerGstin: '',
  buyerName: '',
  totalInvoiceValue: 0,
  irnGenerationDate: '',
  supplyType: SupplyType.B2B,
  invoiceType: InvoiceType.INV,
  ewbNo: null,
  irn: '',
  taxableValue: 0,
  totalTax: 0,
  cancellationReasonCode: null,
  invoiceStatus: InvoiceStatus.NOT_GENERATED,
  errorDetails: null,
  cancellationFailureError: null,
};
